import { all } from 'redux-saga/effects';

import locationsSagas from './locations';

export default function* rootSaga() {
  yield all([locationsSagas()]);
}
